import type React from "react";

export default function SectionItem({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="">{children}</div>
      <div className="my-3 h-px bg-black-200 last:hidden" />
    </>
  );
}
